<template>
  <div>
    <b-form @submit="onSubmit">
      <b-form-group :label="$t('share.content.googlePlus_form_message')">
        <b-form-textarea rows=3 v-model="form.description" required></b-form-textarea>
      </b-form-group>
      <div class="icon-panel">
        <b-col class="text-right">
          <b-button type="submit" variant="primary">{{$t("share.content.googlePlus_form_submit_btn")}}</b-button>
        </b-col>
      </div>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'GooglePlus',
  data() {
    return {
      form: {
        description: ''
      }
    }
  },
  methods: {
    onSubmit() {
      event.preventDefault()
      this.$emit('submit', this.form)
    }
  },
  created() {
    this.$emit("loaded")
  }
}
</script>

